import React from 'react';
import {curry} from 'ramda';
import {Select, MenuItem} from '@material-ui/core';

export interface LabPartnerProps {
    labPartnerField: any;
    labPartners: any;
}

export const mapMenuItem = curry((labPartners, labPartnerItem) => {
    const labPartnerName = labPartners[labPartnerItem];

    return (
        <MenuItem
            key={labPartnerItem}
            value={labPartnerItem}
        >
            {labPartnerName}
        </MenuItem>
    )
});

export default function LabPartnerContainer(props: LabPartnerProps) {
    const {
        labPartnerField,
        labPartners = {},
    } = props;
    const labPartnerKeys: string[] = Object.keys(labPartners);

    return (
        <Select
            onChange={labPartnerField.input.onChange}
            value={labPartnerField.input.value}
            variant="outlined"
        >
            {labPartnerKeys.map(mapMenuItem(labPartners))}
        </Select>
    );
}
